import { Box, Button } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useContext } from 'react'
import useRichTextEditorDialog from '../RichTextEditor/RichTextEditorDialog';
import { Section } from '@microrealestate/commonui/components';
import useTranslation from 'next-translate/useTranslation';
import { StoreContext } from '../../store';
import useFileDescriptorDialog from '../organization/lease/FileDescriptorDialog';
import DocumentList from '../DocumentList';
import { toJS } from 'mobx';
import useFillStore from '../../hooks/useFillStore';

const TemplateItems = observer(function TemplateItems({ onEdit, onDelete }) {
  const store = useContext(StoreContext);
  const templates = store.template.items.filter(({ realmId }) => realmId == store.organization.selected._id);

  return (
    <DocumentList documents={templates} onEdit={onEdit} />
  );
});

async function fetchData(store) {
  // const { param: [leaseId], } = router.query;
  const results = await Promise.all([
    store.template.fetchFields(),
    store.template.fetch(),
  ]);

  return results;
}

const TemplateSettings = observer(() => {
  const store = useContext(StoreContext);
  const { t } = useTranslation('common');
  const [RichTextEditorDialog, setEditTemplate, editTemplate] = useRichTextEditorDialog();
  const [FileDescriptorDialog, setEditFileDescriptor, editFileDescriptor] = useFileDescriptorDialog();
  const [fetching] = useFillStore(fetchData);

  const onSaveTemplate = useCallback(
    async (template) => {
      //setError('');
      if (!template._id) {
        const { status, data } = await store.template.create(template);
        if (status !== 200) {
          // switch (status) {
          //   case 422:
          //     return setError(
          //       t('')
          //     );
          //   case 404:
          //     return setError(t('Template does not exist'));
          //   case 403:
          //     return setError(t(''));
          //   default:
          //     return setError(t('Something went wrong'));
          // }
          return console.error(status);
        }
        if (data.type === 'text') {
          editTemplate._id = data._id;
        } else if (data.type === 'fileDescriptor') {
          editFileDescriptor._id = data._id;
        }
      } else {
        const { status } = await store.template.update(template);
        if (status !== 200) {
          // switch (status) {
          //   case 422:
          //     return setError(
          //       t('')
          //     );
          //   case 404:
          //     return setError(t('Template does not exist'));
          //   case 403:
          //     return setError(t(''));
          //   default:
          //     return setError(t('Something went wrong'));
          // }
          return console.error(status);
        }
      }
    },
    [editFileDescriptor, editTemplate, store.template]
  );

  const onSaveTextTemplate = useCallback(
    async (title, subject, contents, html) => {
      await onSaveTemplate({
        _id: editTemplate?._id,
        name: title,
        subject: subject,
        type: 'text',
        contents,
        html,
        linkedResourceIds: store.lease.selected?._id
          ? [store.lease.selected._id]
          : [],
      });
    },
    [editTemplate?._id, onSaveTemplate, store.lease.selected._id]
  );
  const onLoadTemplate = useCallback(async () => {
    if (!editTemplate || !editTemplate._id) {
      return '';
    }
    store.template.setSelected(
      store.template.items.find(({ _id }) => _id === editTemplate._id)
    );
    
    return store.template.selected.contents;
  }, [store.template, editTemplate]);

  const handleClickEdit = useCallback(
    (template) => {
      if (template.type === 'text') {
        setEditTemplate(template);
      } else if (template.type === 'fileDescriptor') {
        setEditFileDescriptor(template);
      }
    },
    [setEditFileDescriptor, setEditTemplate]
  );

  const onResetTextTemplate = useCallback(
    async () => {
      if (!editTemplate || !editTemplate._id) {
        return '';
      }
      const { data } = await store.template.fetchDefault({ title: editTemplate.name })
      // Return default content
      return data.contents
    },
    [editTemplate, store.template]
  );

  const handleClickAddText = useCallback(() => {
    setEditTemplate({});
  }, [setEditTemplate]);

  return (
    <Box>
      <Section label={t('Template')} subtitle={t('(Email & Whatsapp)')}>
        <TemplateItems onEdit={handleClickEdit} />
      </Section>

      <RichTextEditorDialog
        onLoad={onLoadTemplate}
        onSave={onSaveTextTemplate}
        onReset={onResetTextTemplate}
        title={editTemplate.name}
        subject={editTemplate.subject}
        fields={store.template.fields}
      />
    </Box>
  )
});

export default TemplateSettings;